export enum FileType {
    ARCHIVE = 'archive'
}
